import { CompareActionTypes, ProductComparisonActionTypes, WishListActionTypes } from '../../../enums/ActionEnums';
import { initializeWishListProducts, updateWishListProducts } from '../../wishList/reducers/WishListReducer';
import { toggleComparedStateForItems } from '../../compare/reducers/CompareReducer';
import { setDeliveryPromiseToProducts } from '../../../util/ProductUtil';
export const initialProductComparisonState = [];
export const ProductComparisonReducer = (state = initialProductComparisonState, action) => {
    switch (action.type) {
        case ProductComparisonActionTypes.FETCH:
            return action.payload;
        case ProductComparisonActionTypes.COMPARE_ITEM_SELECT_SIZE: {
            const { productId, colourId, skuId } = action.payload;
            const newItems = [...state];
            const itemIndex = state.findIndex(item => item.productId === productId && item.colourId === colourId);
            newItems[itemIndex] = Object.assign(Object.assign({}, state[itemIndex]), { selectedSku: skuId });
            return newItems;
        }
        case ProductComparisonActionTypes.REMOVE:
            return [...state.slice(0, action.payload.index), ...state.slice(action.payload.index + 1)];
        case CompareActionTypes.COMPARE_UPDATE_PRODUCTS:
            return toggleComparedStateForItems(state, action.payload);
        case WishListActionTypes.UPDATE_PRODUCTS:
            return initializeWishListProducts(state, action);
        case WishListActionTypes.ADD_PRODUCT:
            return updateWishListProducts(state, action, true);
        case WishListActionTypes.REMOVE_PRODUCT:
            return updateWishListProducts(state, action, false);
        case ProductComparisonActionTypes.SET_DELIVERY_PROMISE:
            return setDeliveryPromiseToProducts(state, action.payload);
        default:
            return state;
    }
};
